import magnifiAPIInstance from "./apiInstance";

export const categoryAPIs = {
  getCategory: ({ payload }) => magnifiAPIInstance.post(`/category`, payload),
  getCategoryConfigurationById: ({ payload }) => magnifiAPIInstance.get(`/category-configuration/${payload.category}`),
  addCategory: ({ payload }) => magnifiAPIInstance.post(`/category/create`, payload),
  modifyCategory: ({ payload }) => magnifiAPIInstance.post(`/update/category`, payload),
  deleteCategory: ({ payload }) => magnifiAPIInstance.post(`/category/delete`, payload),
  updateCategoryConfiguration: ({ payload }) => magnifiAPIInstance.post(`/update-category-configuration`, payload),
  assignCategoryToOrganization: ({ payload }) => magnifiAPIInstance.post("/category/assign-to-organization", payload),
};
